import { Box, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';
import type { SanityImage } from '@time-line/components/types';
import { BlogDetails } from 'components/blog/BlogDetails';
import { MediaTag } from 'components/blog/MediaTag';
import { useImage } from 'lib/sanity';
import Img from 'next/image';
import NextLink from 'next/link';
import type { BlogCategory } from 'types/cms/blog/BlogCategory';

interface BlogCardProps {
  type: string;
  title: string;
  slug: string;
  image: SanityImage;
  videoUrl?: string;
  publishedAt: string;
  categories?: BlogCategory[];
  className?: string;
}

export function BlogCard({
  type,
  title,
  slug,
  image,
  videoUrl,
  categories,
  publishedAt,
  className,
}: BlogCardProps) {
  const imageProps = useImage(image, { ratio: 3 / 2 });

  return (
    <LinkBox className={className || 'blog-card'} as={Stack} spacing="xs">
      <Box pos="relative">
        {imageProps && (
          <Img
            {...imageProps}
            alt={image?.alt || title}
            className="round"
            sizes="(min-width: 480px) 50vw, (min-width: 960px) 33vw, 90vw"
          />
        )}
        <MediaTag type={type} videoUrl={videoUrl} />
      </Box>
      <Stack spacing="3xs">
        <BlogDetails categories={categories} publishedAt={publishedAt} />
        <LinkOverlay as={NextLink} href={`/blog/${slug}`}>
          <Text as="h2" size="h5">
            {title}
          </Text>
        </LinkOverlay>
      </Stack>
    </LinkBox>
  );
}
